import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { ButtonPanel } from "../../../../../../../base/buttons/button/index.js";
import Select from "../../../../../select/index.js";
import FlatpickrCalendar from "../../../../../../lib/flatpickr-calendar/index.js";
import Modal from "../../../../../../../structures/others/modal/index.js";
import { differenceInMonths } from "../../../../../../../../helpers/date.js";
import { buildDisableDates, buildEnableDates } from "../../../../helpers/index.js";
import useCalendarMobileModal from "./hooks/useCalendarMobileModal.js";
import useCalendarMobileTimeModal from "./hooks/useCalendarMobileTimeModal.js";
import * as S from "./styled.js";
const CalendarMobileModal = (props)=>{
    const { value =[
        new Date()
    ] , onBlur , locale , mode ='single' , minDate ='today' , maxDate , showMonths =12 , disabledDates =[] , enableTime =false , monthSelectorType ='static' , minuteIncrement =30 , noCalendar =false , disableMobile =true , time24h =true , minTime ='00:00' , maxTime ='23:59' , visible =false , confirm , cancel , modalTitle ='' , timeModalTitle ='' , selectionLabel ='' , modalConfirm , events , releaseDays  } = props;
    const { containerRef , onReady , onChange  } = useCalendarMobileModal(props);
    const { times , timeString , timeValue , handleOnTimeChange , isTimeVisible , hideTime , onConfirm  } = useCalendarMobileTimeModal(props);
    const calendarOptions = useMemo(()=>({
            altInputClass: '',
            wrap: false,
            disable: disabledDates,
            defaultDate: value,
            defaultMinute: 0,
            time_24hr: time24h,
            minDate,
            mode,
            showMonths: minDate !== 'today' && minDate && maxDate ? differenceInMonths(minDate, maxDate) + 2 : showMonths,
            disableMobile,
            monthSelectorType,
            noCalendar,
            minuteIncrement,
            minTime,
            maxTime,
            inline: true,
            static: true
        }), [
        disableMobile,
        disabledDates,
        maxDate,
        maxTime,
        minDate,
        minTime,
        minuteIncrement,
        mode,
        monthSelectorType,
        noCalendar,
        showMonths,
        time24h,
        value
    ]);
    const renderInput = useCallback((_props, ref)=>/*#__PURE__*/ _jsx("div", {
            ref: ref
        }), []);
    const finalDisableDates = buildDisableDates(props);
    const finalEnableDates = buildEnableDates(props, finalDisableDates);
    const confirmModal = ()=>{
        confirm();
        onBlur?.();
    };
    const cancelModal = ()=>{
        cancel();
        onBlur?.();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Modal, {
                visible: visible,
                hide: cancelModal,
                header: modalTitle,
                contentRef: containerRef,
                content: /*#__PURE__*/ _jsx(S.FlatpickrCalendarWrapper, {
                    children: /*#__PURE__*/ _jsx(FlatpickrCalendar, {
                        id: "calendar-id",
                        locale: locale,
                        render: renderInput,
                        value: value,
                        options: calendarOptions,
                        onReady: onReady,
                        onChange: onChange,
                        enableDates: finalEnableDates,
                        events: events,
                        releaseDays: releaseDays
                    })
                }),
                variant: "fullScreen",
                color: "primary",
                footer: !enableTime && mode === 'range' && value.length === 2 && /*#__PURE__*/ _jsx(ButtonPanel, {
                    onClick: confirmModal,
                    children: modalConfirm
                })
            }),
            enableTime && /*#__PURE__*/ _jsx(Modal, {
                visible: isTimeVisible,
                hide: hideTime,
                variant: "fullScreen",
                color: "primary",
                iconLeft: "angle-left",
                iconRight: "",
                header: timeModalTitle || modalTitle,
                content: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsxs(S.TimeValue, {
                            children: [
                                selectionLabel,
                                " ",
                                /*#__PURE__*/ _jsx("span", {
                                    children: timeString
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Select, {
                            value: timeValue,
                            onChange: handleOnTimeChange,
                            options: times,
                            enableSearch: false,
                            variant: "without-modal",
                            menuVariant: "floating"
                        })
                    ]
                }),
                footer: /*#__PURE__*/ _jsx(ButtonPanel, {
                    onClick: onConfirm(confirmModal),
                    children: modalConfirm
                })
            })
        ]
    });
};
export default CalendarMobileModal;

//# sourceMappingURL=index.js.map